// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"a487bcf2","377":"27c0710b","704":"f51ed3d0","739":"73f3bc38","856":"b95ab2a9","879":"92500088","993":"93ce2654"}[chunkId] + ".chunk.js";
};